import axios from 'axios'

import { ILog } from '@/types/log'
import { IQlog, QlogParams } from '@/types/qlog'

export const createLog = async (log: IQlog): Promise<IQlog> => {
  try {
    const response = await axios.post<IQlog>('qlogs', log)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.qlogs.createLog')
  }
}

export const getLogs = async (params: QlogParams): Promise<ILog[]> => {
  const config = {
    timeout: 1000 * 60 * 10, // 10 min
    params,
  }
  try {
    const response = await axios.get<ILog[]>('qlogs', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.qlogs.getLogs')
  }
}
